import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id 31B62839-D838-41FE-86B8-313070BBB0A9
 * name alpha-m
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-m.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphaMIcon = createSvgIcon(<><path d="M9,7A2,2 0 0,0 7,9V17H9V9H11V16H13V9H15V17H17V9A2,2 0 0,0 15,7H9Z" /></>, 'AlphaMIcon');
export default AlphaMIcon